import React, { useState } from 'react';
import { Check, Star, ChevronDown } from 'lucide-react';
import { formatUsd } from '../config/tiers';
import TierDetails from './TierDetails';
import { trackEvent } from '../utils/tracking';
import './TierCard.css';

export default function TierCard({ tier, selected, onSelect }) {
  const [detailsOpen, setDetailsOpen] = useState(false);

  const toggleDetails = (e) => {
    e.stopPropagation();
    const opening = !detailsOpen;
    setDetailsOpen(opening);
    if (opening) trackEvent('Tier Details Expanded', { tier: tier.key });
  };

  return (
    <div
      className={`tp-tier-card card${selected ? ' tp-tier-card--selected' : ''}${tier.popular ? ' tp-tier-card--popular' : ''}`}
      onClick={() => onSelect(tier.key)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect(tier.key);
        }
      }}
      role="button"
      tabIndex={0}
      aria-pressed={selected}
    >
      {tier.popular && (
        <span className="tp-tier-card__chip label-s">
          <Star size={12} strokeWidth={0} fill="currentColor" />
          Most popular
        </span>
      )}
      <h3 className="title-l tp-tier-card__name">{tier.name}</h3>
      <p className="body-s tp-tier-card__tagline">{tier.tagline}</p>
      <div className="tp-tier-card__price-row">
        {tier.originalPriceCents && (
          <span className="body-s tp-tier-card__price-original">{formatUsd(tier.originalPriceCents)}</span>
        )}
        <span className="display-3 tp-tier-card__price">{formatUsd(tier.priceCents)}</span>
        <span className="body-s tp-tier-card__price-caption">per traveler</span>
      </div>
      <ul className="tp-tier-card__features">
        {tier.features.map((f) => (
          <li key={f}>
            <span className="tp-tier-card__check">
              <Check size={13} strokeWidth={2.5} />
            </span>
            <span className="body-m">{f}</span>
          </li>
        ))}
      </ul>
      <p className="body-s tp-tier-card__value">
        Over {formatUsd(tier.valueCents)} in value
      </p>

      <button type="button" className="tp-tier-card__toggle" onClick={toggleDetails} aria-expanded={detailsOpen}>
        {detailsOpen ? 'Hide details' : 'See what\'s included'}
        <ChevronDown size={16} strokeWidth={1.5} className={`tp-tier-card__toggle-chevron${detailsOpen ? ' tp-tier-card__toggle-chevron--open' : ''}`} />
      </button>

      {detailsOpen && <TierDetails tier={tier} />}
    </div>
  );
}
